// extracted by mini-css-extract-plugin
var _1 = "CommentAuthor-module__animateUploadProgressBarWidth--w9yj3";
var _2 = "CommentAuthor-module__animatedBackground--zHCON";
var _3 = "CommentAuthor-module__container--qPSVi";
var _4 = "CommentAuthor-module__labels--QY7v8";
var _5 = "CommentAuthor-module__name--rfnfS";
var _6 = "CommentAuthor-module__timestamp--WVEK1";
var _7 = "CommentAuthor-module__timestampButton--q0B5f";
var _8 = "CommentAuthor-module__timestamps--Ce0hE";
var _9 = "CommentAuthor-module__tooltip--_YrMK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "labels", _5 as "name", _6 as "timestamp", _7 as "timestampButton", _8 as "timestamps", _9 as "tooltip" }
